import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../constants/colors";

export default makeStyles((theme) => ({
  pageContainer: {
    height: "75vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  headerText: {
    fontFamily: "Montserrat",
    color: `${COLORS.accent}`,
  },
  contentText: {
    fontFamily: "Blinker",
    fontSize: 20,
    color: `${COLORS.accent}`,
  },
  link: {
    color: `${COLORS.accent}`,
    "&:hover": {
      color: `${COLORS.accent}`,
    },
    textDecoration: "underline",
  },
}));
